import type { PayloadAction } from '@reduxjs/toolkit'
import {
  CONVENIENCE_TEST_STAGES_ID,
  RELATED_STAGE_2_TO_3_QUESTIONS_IDS,
  UpdateExtraAnswerPayload,
} from '@repo/user-types'
import { put, takeEvery } from 'redux-saga/effects'
import { convenienceTestQuestionnaireAnswersActions } from '../../slices'

function* updateExtraAnswer(action: PayloadAction<UpdateExtraAnswerPayload>) {
  const { answerId, questionId, stage, value } = action.payload

  const relatedQuestionId =
    RELATED_STAGE_2_TO_3_QUESTIONS_IDS[
      questionId as keyof typeof RELATED_STAGE_2_TO_3_QUESTIONS_IDS
    ] ?? questionId

  if (stage === CONVENIENCE_TEST_STAGES_ID.STAGE_2) {
    yield put(
      convenienceTestQuestionnaireAnswersActions.updateExtraAnswer({
        stage: CONVENIENCE_TEST_STAGES_ID.STAGE_3,
        questionId: relatedQuestionId,
        answerId,
        value: '1',
      }),
    )
    if (value === '1') {
      yield put(
        convenienceTestQuestionnaireAnswersActions.updateContrastAnswers({
          stage: CONVENIENCE_TEST_STAGES_ID.STAGE_3,
          questionId: relatedQuestionId,
          answerId,
          value: { answer: value, answerId: '1', questionId: relatedQuestionId },
        }),
      )
    }
    yield put(
      convenienceTestQuestionnaireAnswersActions.updateContrastAnswers({
        stage,
        questionId,
        answerId,
        value: null,
      }),
    )
  }

  if (stage === CONVENIENCE_TEST_STAGES_ID.STAGE_3 && value === '1') {
    yield put(
      convenienceTestQuestionnaireAnswersActions.updateContrastAnswers({
        stage,
        questionId,
        answerId,
        value: { answer: value, answerId: '1', questionId },
      }),
    )
  }
}

export function* watchUpdateRelatedFieldsAnswers() {
  yield takeEvery(
    convenienceTestQuestionnaireAnswersActions.updateExtraAnswer.type,
    updateExtraAnswer,
  )
}
